import Vue from 'vue'
import VueCookie from 'vue-cookie'
import VueLazyload from 'vue-lazyload'
import Vuelidate from 'vuelidate'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import Vant from 'vant'
import 'vant/lib/index.css'
import router from './router'
import store from './store/'
import App from './App'

Vue.use(ToastPlugin)
Vue.use(LoadingPlugin)
Vue.use(ElementUI)
Vue.use(Vant)
Vue.use(VueCookie)
Vue.use(VueLazyload, {
loading: '/static/images/load.gif',
})
Vue.use(Vuelidate)

Vue.config.productionTip = false
router.beforeEach(function (to, from, next) {
store.commit('GET_WXINFO')
if (store.state.wxInfo === null && to.path !== '/authorize') {


var state = 'state'
if (to.path == '/huiyizhibo' && to.query.vip == '1') {
state = 'vip'
next()
} else {
window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxbd939bf00ad557d4&redirect_uri=http%3A%2F%2Fwww.cghsp.com%2Fauthorize&response_type=code&scope=snsapi_base&state='+state+'#wechat_redirect'
}

} else {
next()
}
})

Vue.filter('getImg', function (value) {
return '/static/images/' + value
})

/* eslint-disable no-new */
new Vue({
el: '#app',
store,
router,
render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js